import { ProductAttributeGroupMember } from '@congacommerce/ecommerce';
import { Expose } from 'class-transformer';

export class ProductAttributeGroupMemberExtended extends ProductAttributeGroupMember {
    @Expose({ name: 'egl_SalesProcess__c' })
    SalesProcess: string;
}
